import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Icon - Cart - Fill" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M19.394 17.207a2.24 2.24 0 0 0 2.126-1.713l2.461-9.509a.584.584 0 0 0-.392-.71.636.636 0 0 0-.141-.022H4.937L3.678.428A.558.558 0 0 0 3.145 0H0v1.155h2.706l1.218 4.714a.415.415 0 0 0 0 .114l2.508 9.541a1.961 1.961 0 0 0 .068.233l.846 3.2a2.689 2.689 0 0 0-1.369 2.364 2.63 2.63 0 0 0 2.581 2.678 2.63 2.63 0 0 0 2.581-2.678 2.765 2.765 0 0 0-.313-1.279 3.185 3.185 0 0 0-.152-.26h6.567a2.75 2.75 0 0 0-.47 1.54 2.583 2.583 0 1 0 5.162 0 2.716 2.716 0 0 0-.679-1.811 2.469 2.469 0 0 0-1.87-.884H8.459l-.392-1.491a2.047 2.047 0 0 0 .512.07Zm-.037 2.575a1.541 1.541 0 1 1-1.484 1.54 1.511 1.511 0 0 1 1.484-1.54Zm-10.8 0a1.541 1.541 0 1 1-1.484 1.54 1.511 1.511 0 0 1 1.485-1.54Z",
        "data-name": "Gruppe 508"
      })
    ], -1)
  ])))
}
export default { render: render }